<template>
  <div class="contract-numbers-container">
    <MdTypography
      @mouseover="checkEllipsis"
      ref="contractNumbersRef"
      v-tooltip="isTruncated ? { content: displayContractNumbers, placement: 'bottom' } : ''"
      class="contract-numbers-text"
      data-qa-id="font-display-styles--contractNumbers" tag="div" color="spirits--900" variant="body2--regular"
    >
      {{ displayContractNumbers }}
    </MdTypography>
  </div>
</template>

<script>
import { computed, ref } from 'vue'
import { MdTypography } from '@antiqua-dls/vue-components'

export default {
  name: 'ContractNumbersCol',
  components: {
    MdTypography
  },
  props: {
    params: {
      type: Object,
      required: true
    },
  },
  setup(props) {
    const { data } = props.params
    const contractNumbersRef = ref(null)
    const isTruncated = ref(false)
    const displayContractNumbers = computed(() => {
      const contracts = data['contractNumbers'] || []
      return contracts.join(', ')
    })

    const checkEllipsis = () => {
      const el = contractNumbersRef.value?.$el?.shadowRoot?.querySelector('[part="md-typography"]')
      console.log(el, 'el');
      console.log(el.scrollWidth, el.clientWidth, 'el.scrollWidth, el.clientWidth');
      
      if (el) {
        isTruncated.value = el.scrollWidth > el.clientWidth
      }
    }

    return {
      contractNumbersRef,
      displayContractNumbers,
      checkEllipsis,
      isTruncated
    };
  }
}
</script>

<style lang="scss">
.contract-numbers-container {
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  min-width: 0;
  .contract-numbers-text {
    &::part(md-typography) {
      display: block;
      white-space: nowrap;            
      overflow: hidden;               
      text-overflow: ellipsis;        
      width: 11rem;
    }
  }
}
</style>
